export { NotifyModule } from './notify.module';
export { NotifyService } from './notify.service';
export { ModalComponent } from './modal-component';
export { ToastType } from './toast/toast-type.enum';



// WEBPACK FOOTER //
// /dist/src/app/notify/index.ts